/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../../$$_gendir/node_modules/angular2-spinner/dist/angular2-spinner.ngfactory';
import * as import2 from 'angular2-spinner/dist/angular2-spinner';
import * as import3 from '@angular/common';
import * as import4 from 'ngx-pagination';
import * as import5 from '../../../$$_gendir/node_modules/ngx-pagination/dist/ngx-pagination.ngfactory';
import * as import6 from '@angular/router';
import * as import7 from '../../../app/news/news-list.component';
import * as import8 from '../../../app/services/news.service';
import * as import9 from '../../../app/services/local-storage.service';
import * as import10 from 'angular2-notifications/src/notifications.service';
const styles_NewsListComponent:any[] = ([] as any[]);
export const RenderType_NewsListComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_NewsListComponent,
  data: {}
}
);
function View_NewsListComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'spinner center-v-h'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'p',[[
        'class',
        'spinner-label'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Wczytywanie listy aktualności'])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'spinner',([] as any[]),[
      [
        4,
        'width',
        'px'
      ]
      ,
      [
        4,
        'height',
        'px'
      ]
      ,
      [
        4,
        'borderWidth',
        'px'
      ]
      ,
      [
        4,
        'borderTopColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderBottomColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderLeftColor',
        (null as any)
      ]
      ,
      [
        4,
        'borderRightColor',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),import1.View_SpinnerComponent_0,import1.RenderType_SpinnerComponent)),
    import0.ɵdid(114688,(null as any),0,import2.SpinnerComponent,([] as any[]),{
      size: [
        0,
        'size'
      ]
      ,
      tickness: [
        1,
        'tickness'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    const currVal_7:any = 35;
    const currVal_8:any = 3;
    ck(v,6,0,currVal_7,currVal_8);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,6).size;
    const currVal_1:any = import0.ɵnov(v,6).size;
    const currVal_2:any = import0.ɵnov(v,6).tickness;
    const currVal_3:any = import0.ɵnov(v,6).color;
    const currVal_4:any = import0.ɵnov(v,6).secondColor;
    const currVal_5:any = import0.ɵnov(v,6).secondColor;
    const currVal_6:any = import0.ɵnov(v,6).secondColor;
    ck(v,5,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_NewsListComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'empty-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Brak aktualności do wyświetlenia'])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(null as any));
}
function View_NewsListComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'td',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'td',[[
        'style',
        'white-space: pre-line;'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = v.context.$implicit.title;
    ck(v,3,0,currVal_0);
    const currVal_1:any = v.context.$implicit.date_start;
    ck(v,6,0,currVal_1);
    const currVal_2:any = v.context.$implicit.message;
    ck(v,8,0,currVal_2);
  });
}
function View_NewsListComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'table-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'table',[[
        'class',
        'standard'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),13,'thead',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),10,'tr',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',[[
        'style',
        'width:20%'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Tytuł'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',[[
        'style',
        'width:20%'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['D. aktualności'])),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'th',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Treść'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),6,'tbody',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),3,(null as any),View_NewsListComponent_4)),
    import0.ɵdid(802816,(null as any),0,import3.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    import0.ɵpod([
      'itemsPerPage',
      'currentPage'
    ]
    ),
    import0.ɵpid(0,import4.PaginatePipe,[import4.PaginationService]),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'pagination-controls',[
      [
        'directionLinks',
        'true'
      ]
      ,
      [
        'nextLabel',
        'Następne'
      ]
      ,
      [
        'previousLabel',
        'Poprzednie'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'pageChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('pageChange' === en)) {
        const pd_0:any = ((<any>(co.p = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import5.View_PaginationControlsComponent_0,import5.RenderType_PaginationControlsComponent)),
    import0.ɵdid(49152,(null as any),0,import4.PaginationControlsComponent,([] as any[]),{
      directionLinks: [
        0,
        'directionLinks'
      ]
      ,
      previousLabel: [
        1,
        'previousLabel'
      ]
      ,
      nextLabel: [
        2,
        'nextLabel'
      ]

    }
    ,{pageChange: 'pageChange'}),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,22,0,import0.ɵnov(v,24).transform(co.news,ck(v,23,0,5,co.p)));
    ck(v,22,0,currVal_0);
    const currVal_1:any = 'true';
    const currVal_2:any = 'Poprzednie';
    const currVal_3:any = 'Następne';
    ck(v,29,0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
export function View_NewsListComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),39,'main',[[
        'class',
        'main'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),36,'div',[[
        'class',
        'container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewsListComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'filters'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),19,'header',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',[[
        'class',
        'section-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Lista aktualności:'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'a',[[
        'class',
        'inactive heading-h3'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Aktualne'])),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[
      [
        'class',
        'heading-h3'
      ]
      ,
      [
        'routerLink',
        '/news/history'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,25).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import6.RouterLinkWithHref,[
      import6.Router,
      import6.ActivatedRoute,
      import3.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Historia'])),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'bar columns tall'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewsListComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NewsListComponent_3)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import7.NewsListComponent = v.component;
    const currVal_0:any = co.newsListLoading;
    ck(v,5,0,currVal_0);
    const currVal_3:any = '/news/history';
    ck(v,25,0,currVal_3);
    const currVal_4:boolean = (!co.newsListLoading && !co.news.length);
    ck(v,34,0,currVal_4);
    const currVal_5:any = (co.news.length && !co.newsListLoading);
    ck(v,37,0,currVal_5);
  },(ck,v) => {
    const currVal_1:any = import0.ɵnov(v,25).target;
    const currVal_2:any = import0.ɵnov(v,25).href;
    ck(v,24,0,currVal_1,currVal_2);
  });
}
function View_NewsListComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-main',([] as any[]),(null as any),(null as any),(null as any),View_NewsListComponent_0,RenderType_NewsListComponent)),
    import0.ɵdid(114688,(null as any),0,import7.NewsListComponent,[
      import8.NewsService,
      import9.LocalStorageService,
      import10.NotificationsService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const NewsListComponentNgFactory:import0.ComponentFactory<import7.NewsListComponent> = import0.ɵccf('app-main',import7.NewsListComponent,View_NewsListComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/news/news-list.component.ngfactory.ts